import React from "react";
import styled, { css } from "styled-components";
import { useHasOverflow } from "@churchofjesuschrist/eden-has-overflow";
import { spacing96 } from "@churchofjesuschrist/eden-style-constants";
import PropTypes from "prop-types";
const Root = styled.div.withConfig({
  componentId: "sc-12r07va-0"
})(["max-width:100%;height:100%;"]);
const Layout = styled.div.withConfig({
  componentId: "sc-12r07va-1"
})(["position:relative;"]);
const Track = styled.div.withConfig({
  componentId: "sc-12r07va-2"
})(["overflow-x:scroll;visibility:hidden;scrollbar-width:none;&::-webkit-scrollbar{display:none;}&:not(*:root){visibility:visible;}"]);
const InnerTrack = styled.div.withConfig({
  componentId: "sc-12r07va-3"
})(["visibility:visible;"]);
const fade = css(["position:absolute;top:0;bottom:0;width:", ";pointer-events:none;"], spacing96);
const FadeLeft = styled.div.withConfig({
  componentId: "sc-12r07va-4"
})(["", ";left:0;background:linear-gradient( to left,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100% );"], fade);
const FadeRight = styled.div.withConfig({
  componentId: "sc-12r07va-5"
})(["", ";right:0;background:linear-gradient( to right,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100% );"], fade);

const ScrollTrack = _ref => {
  let {
    children,
    onScroll,
    ...props
  } = _ref;
  const [overflowRef, {
    hasLeft,
    hasRight
  }] = useHasOverflow();
  return /*#__PURE__*/React.createElement(Root, props, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Track, {
    ref: overflowRef,
    onScroll: onScroll
  }, /*#__PURE__*/React.createElement(InnerTrack, null, children)), hasLeft ? /*#__PURE__*/React.createElement(FadeLeft, null) : null, hasRight ? /*#__PURE__*/React.createElement(FadeRight, null) : null));
};

ScrollTrack.propTypes = {
  /** Handler for the `scroll` event. */
  onScroll: PropTypes.func,

  /** Contents of the scroll track. */
  children: PropTypes.node
};
export default ScrollTrack;